// src/components/StatCard.js
import React from 'react';

const StatCard = ({ title, value, change, period, icon, iconBgColor, iconTextColor, arrowColor, isPositive }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md flex items-center justify-between">
      <div>
        <h3 className="text-gray-500 text-sm font-medium mb-1">{title}</h3>
        <p className="text-2xl font-bold text-gray-900 mb-2">{value}</p>
        <div className={`flex items-center text-sm ${arrowColor}`}>
          <span className="mr-1">
            {isPositive ? (
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 10l7-7m0 0l7 7m-7-7v18"
                ></path>
              </svg>
            ) : (
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 14l-7 7m0 0l-7-7m7 7V3"
                ></path>
              </svg>
            )}
          </span>
          <span>{change} {period && <span className="text-gray-500">{period}</span>}</span>
        </div>
      </div>
      <div className={`p-3 rounded-full ${iconBgColor}`}>
        <span className={`text-2xl ${iconTextColor}`}>{icon}</span>
      </div>
    </div>
  );
};

export default StatCard;